/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tap_To_Select_PhotosInputs */

const en_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to select photos`)
};

const es_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca para seleccionar fotos`)
};

const fr_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appuyez pour sélectionner des photos`)
};

const de_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippen, um Fotos auszuwählen`)
};

const ja_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タップして写真を選択`)
};

const zh_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击选择照片`)
};

const ar_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انقر لتحديد الصور`)
};

const id_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketuk untuk memilih foto`)
};

const it_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca per selezionare le foto`)
};

const ru_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите, чтобы выбрать фотографии`)
};

const pt_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque para selecionar fotos`)
};

const ko_tap_to_select_photos = /** @type {(inputs: Tap_To_Select_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사진을 선택하려면 탭하세요`)
};

/**
* | output |
* | --- |
* | "Tap to select photos" |
*
* @param {Tap_To_Select_PhotosInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tap_to_select_photos = /** @type {((inputs?: Tap_To_Select_PhotosInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tap_To_Select_PhotosInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tap_to_select_photos(inputs)
	if (locale === "es") return es_tap_to_select_photos(inputs)
	if (locale === "fr") return fr_tap_to_select_photos(inputs)
	if (locale === "de") return de_tap_to_select_photos(inputs)
	if (locale === "ja") return ja_tap_to_select_photos(inputs)
	if (locale === "zh") return zh_tap_to_select_photos(inputs)
	if (locale === "ar") return ar_tap_to_select_photos(inputs)
	if (locale === "id") return id_tap_to_select_photos(inputs)
	if (locale === "it") return it_tap_to_select_photos(inputs)
	if (locale === "ru") return ru_tap_to_select_photos(inputs)
	if (locale === "pt") return pt_tap_to_select_photos(inputs)
	return ko_tap_to_select_photos(inputs)
});